export const PROD_URL = "https://app.ipaddi.net"
